import { Box, LinearProgress, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import { useAppSelector } from "../../redux/hooks";

export const JobsTray = ({ show, onClose }: { show: boolean; onClose: () => void }) => {
  const jobs = useAppSelector(state => state.jobs.jobs);

  if (!show) return null;

  const sortedJobs = jobs.slice().sort((a, b) => b.id.localeCompare(a.id)); // Sort by id in reverse order

  return (
    <Box
      style={{
        position: "fixed",
        top: "4rem",
        right: 0,
        width: "350px",
        height: "100%",
        backgroundColor: "#ffffff",
        boxShadow: "-2px 0 10px rgba(0,0,0,0.2)",
        zIndex: 999,
        overflowY: "auto",
        padding: "1rem",
        borderLeft: "1px solid #ddd",
      }}
    >
      <Box
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
          borderBottom: "1px solid #ddd",
          paddingBottom: "0.5rem",
        }}
      >
        <Typography variant="h6" style={{ fontWeight: "bold" }}>
          Active Jobs
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
      <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
        {sortedJobs.map((job) => (
          <li
            key={job.id}
            style={{
              marginBottom: "1.5rem",
              padding: "1rem",
              border: "1px solid #ddd",
              borderRadius: "8px",
              backgroundColor: "#f9f9f9",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Typography variant="body1" style={{ fontWeight: "bold" }}>
              {job.name}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={job.progress}
              style={{
                marginTop: "0.5rem",
                height: "10px",
                borderRadius: "5px",
                backgroundColor: job.status === "errored" ? "#ffe6e6" : "",
              }}
            />
            <Typography
              variant="caption"
              style={{
                display: "block",
                marginTop: "0.5rem",
                color:
                  job.status === "completed"
                    ? "green"
                    : job.status === "errored"
                      ? "red"
                      : "gray",
              }}
            >
              {job.status === "completed"
                ? "Completed"
                : job.status === "errored"
                  ? "Errored"
                  : `${job.progress}%`}
            </Typography>
          </li>
        ))}
      </ul>
    </Box>
  );
};
